// extracted by mini-css-extract-plugin
module.exports = {"main":"_3cJm7","doubleCards":"_1NPrF","card":"_L1Aa"};